import type { UserUuid } from "../identity";
export const DIRECTION_LABEL: Record<string, string> = {
	outbound: "Sent",
	inbound: "Received",
};

export const CHANNEL_LABELS: Record<string, string> = { email: 'Email', sms: 'SMS', push: 'Push' };

const STATUS_LABELS: Record<string, string> = { sent: 'Sent', failed: 'Failed', received: 'Received', delivered: 'Delivered' };

// StatusTag has no `sent` entry, so an unlabelled tag would render the raw lowercase value.
export const statusLabel = (value: string): string =>
	STATUS_LABELS[value] ?? (value ? value.charAt(0).toUpperCase() + value.slice(1) : '—');

export interface SendCommunicationRequest {
	recipient_user_id: UserUuid;
	category: string;
	id?: number;
	data?: any;
	channels?: ('push' | 'email' | 'sms')[];
	company_id?: number;
	user_id?: UserUuid;
	email_signature_id?: number;
	push_title?: string;
	push_type?: 'alert' | 'info' | 'error' | 'warning';
	related_entity_id?: string;
}

export interface SendCommunicationResponse {
	message: string;
	channels: Record<string, string>;
}